<script>
import eventBus from '@/helpers/eventBus';

const POLILINE_DEFAULT_OPTIONS = {
  geodesic: true,
  strokeColor: '#039BE5',
  strokeOpacity: 0.6,
  strokeWeight: 10,
};
export default {
  name: 'GoogleMapLine',
  props: {
    google: {
      type: Object,
      required: true,
    },
    map: {
      type: Object,
      required: true,
    },
    linea: {
      type: Object,
      required: true,
    },
  },
  methods: {
    setLinea() {
      const linea = new this.google.maps.Polyline({
        ...POLILINE_DEFAULT_OPTIONS,
        path: this.linea.path,
      });

      linea.addListener('click', () => {
        eventBus.$emit('details', this.linea.idReference);
      });

      linea.setMap(this.map);
    },
  },

  mounted() {
    this.setLinea();
  },
  render() {
    return {};
  },
};
</script>
